import { useQuery } from 'react-query';

import useApiHelper from '../../../hooks/useApiHelper';

import { IDataPoint } from '../../../types/DataPoint/DataPoint';
import { IDefaultResponseWithData } from '../../../types/system/DefaultResponse';
import useQSBuilder from '../../../hooks/useQSBuilder';

export default function useSuperAdminDataPoints(
  hardwareType?: string,
  includeDeleted = false
) {
  const { get } = useApiHelper();
  const buildQS = useQSBuilder();

  const dataPoints = useQuery({
    queryKey: ['superadmin', 'datapoints', hardwareType, includeDeleted],
    queryFn: () =>
      get<IDefaultResponseWithData<IDataPoint>>(
        `/v1/superadmin/datapoint${hardwareType ? `/${hardwareType}` : ''}${buildQS({ includeDeleted })}`
      ).then((res) => res.data.data),
  });

  return {
    dataPoints,
  };
}
